import { getPatientListApi } from '@/api/patientList';

const PER_PAGE = 20;

const state = {
  patients: {},       // keyed by patient_id string
  lastPage: 0,        // last loaded page number
  perPage: PER_PAGE,
  totalCount: 0,      // total_count from API
  loading: false,
};

const getters = {
  /** Sorted patient array (stable order by patient_id) */
  patientList: (state) => {
    return Object.values(state.patients);
  },

  hasMore: (state) => {
    if (state.lastPage === 0) return true;
    return state.lastPage * state.perPage < state.totalCount;
  },
};

const mutations = {
  ADD_PATIENTS(state, { patients, page }) {
    if (!Array.isArray(patients)) return;
    patients.forEach((p) => {
      if (p.patient_id) {
        state.patients[String(p.patient_id)] = p;
      }
    });
    if (page && page > state.lastPage) {
      state.lastPage = page;
    }
  },

  SET_TOTAL_COUNT(state, count) {
    state.totalCount = count;
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  RESET(state) {
    state.patients = {};
    state.lastPage = 0;
    state.totalCount = 0;
    state.loading = false;
  },
};

const actions = {
  /**
   * Fetch the next page of patients from findPatient API.
   * Returns the newly fetched patients array (empty if no more or already loading).
   */
  async fetchNextPage({ state, commit, getters }) {
    if (state.loading) return [];
    if (!getters.hasMore) return [];

    commit('SET_LOADING', true);
    const nextPage = state.lastPage + 1;

    try {
      const response = await getPatientListApi({
        page: String(nextPage),
        perPage: String(state.perPage),
        search_patient_field: '',
        search_patient_type: 'patient_name',
      });

      if (response && Array.isArray(response.patients)) {
        const newPatients = response.patients;
        if (newPatients.length === 0) {
          // No more data — cap totalCount so hasMore becomes false
          commit('SET_TOTAL_COUNT', state.lastPage * state.perPage);
          return [];
        }

        commit('SET_TOTAL_COUNT', response.total_count || 0);
        commit('ADD_PATIENTS', { patients: newPatients, page: nextPage });
        return newPatients;
      }
      return [];
    } catch (error) {
      console.error('Failed to fetch patient page:', error);
      return [];
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
